import { IS_PRODUCTION } from "utils/env-management"
import { httpClient } from "utils/infrastructure/httpClient"

export function logEvent(json: { event?: string; data?: object; test?: string }) {
    if (!IS_PRODUCTION) {
        console.log(`logEvent(${JSON.stringify(json)})`)
    }
    void httpClient.post("log", json).then(undefined).catch(undefined)
}
